import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import phoneValid from '../../../utils/phoneValid';
import emailValid from '../../../utils/emailValid';
import fileUpload from '../../../utils/fileUpload';
import deleteFile from '../../../utils/deleteFile';
import { orgGuidRegisterFun } from '../../../api/orgGuidAPI';
import { orgCampRegisterFun } from '../../../api/orgCampAPI';
import { orgActRegisterFun } from '../../../api/orgActAPI';

export default async function supOrgRegSubmit(
    formData,
    setLoading,
    // conPass,
    accRe,
    logoData,
    tempData,
    imgData,
    videoFile,
    isEdit,
    refs = {}
) {
    //check if all the data is filled properly, if not show error
    //later send data to backend for registration
    if (formData.type === 'Select') {
        toast.error('Please selecte Type');
        return;
    } else if (3 > formData.companyName.length || formData.companyName.length > 70) {
        toast.error('Error in Company Name');
        return;
    }
    const checkOwner = formData.owner.every((item) => {
        return Object.values(item).every((ele) => ele === '');
    });
    if (checkOwner) {
        toast.error('Error in Owner Details');
        return;
    }
    const checkOwnPh = formData.owner.every((owner) => phoneValid(owner.phoneNumber));
    if (!checkOwnPh) {
        toast.error('Error in owner phone number');
        return;
    }
    const checkOwnEmail = formData.owner.every((owner) => emailValid(owner.emailId));
    if (!checkOwnEmail) {
        toast.error('Error in owner email Id');
        return;
    }
    if (formData.typeofCompany === 'Select') {
        toast.error('Please selecte Company Type');
        return;
    }
    if (50 > formData.about.length || formData.about.length > 1000) {
        toast.error('Please type atleast 50 characters in about us');
        return;
    }
    if (!logoData) {
        toast.error('Please select a logo');
    }
    if (formData.gst === '') {
        toast.error('Error in GST');
        return;
    }
    // if (formData.cin === '') {
    //     toast.error('Error in CIN');
    //     return;
    // }
    if (formData.countryCode === '') {
        toast.error('Error in Country Code');
        return;
    }
    if (!phoneValid(formData.phoneNumber)) {
        toast.error('Enter a valid phone number');
        return;
    }
    if (!emailValid(formData.emailId)) {
        toast.error('Enter a valid email id');
        return;
    }
    if (!phoneValid(formData.contactPerson.phoneNumber)) {
        toast.error('Error in contact person phone number');
        return;
    }
    if (!emailValid(formData.contactPerson.emailId)) {
        toast.error('Error in contact person email Id');
        return;
    }
    // if (formData.password !== conPass) {
    //   toast.error("Passwords dont match");
    //   return;
    // }
    const checkAdd = Object.values(formData.address).every((item) => item === '');
    if (checkAdd) {
        toast.error('Error in Address');
        return;
    }
    const checkContact = Object.values(formData.contactPerson).every((item) => item === '');
    if (checkContact) {
        toast.error('Error in Contact Person');
        return;
    }
    if (formData.contactPerson.phoneNumber.length !== 10) {
        toast.error('Error in Contact Persons Phone Number');
        return;
    }
    const checkBank = Object.values(formData.bank).some((item) => item === '');

    if (checkBank) {
        toast.error('Error in Bank Details');
        return;
    }
    if (formData.bank.accNum !== accRe) {
        toast.error('Account Numbers Dont Match');
        return;
    }
    if (!formData.phoneOTP) {
        toast.error('Enter phone OTP');
        return;
    }
    if (!formData.emailOTP) {
        toast.error('Enter email OTP');
        return;
    }

    if (formData.type === 'Camp') {
        const quickView = formData.quickView;

        const fieldsToValidate = ['where', 'food', 'baseCities'];

        for (const field of fieldsToValidate) {
            const value = quickView[field];

            const isEmptyString = typeof value === 'string' && value.trim() === '';
            const isInvalidStringValue = value === '-1';
            const isNullOrUndefined = value === null || value === undefined;

            if (isEmptyString || isInvalidStringValue || isNullOrUndefined) {
                const label = field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1');

                toast.error(`Quickview ${label} is required.`);
                // refs.quickViewRef?.current?.scrollToAndHighlightField(field);
                return;
            }
        }

        if ((imgData?.oldWallImg?.length || 0) + (imgData?.newWallImg?.length || 0) < 5) {
            toast.error('Upload at least 5 Wallpaper Images');
            refs.imageRef?.current?.scrollToAndHighlightField('');
            return;
        }

        if ((imgData?.oldThumbImg?.length || 0) + (imgData?.newThumbImg?.length || 0) < 2) {
            toast.error('Upload at least 2 Thumbnail Images');
            refs.imageRef?.current?.scrollToAndHighlightField('');
            return;
        }
        if (20 > tempData.included.length || tempData.included.length > 800) {
            toast.error('Add atleast 2 includes');
            refs.inExRef?.current?.scrollToAndHighlightField('included');
            return;
        }
        if (20 > tempData.excluded.length || tempData.excluded.length > 800) {
            toast.error('Add atleast 2 excludes');
            refs.inExRef?.current?.scrollToAndHighlightField('excluded');
            return;
        }
        if (20 > tempData.safety.length || tempData.safety.length > 800) {
            toast.error('Add atleast 2 safety points');
            refs.safetyRef?.current?.scrollToAndHighlightField('safety');
            return;
        }

        if (20 > tempData.carry.length || tempData.carry.length > 800) {
            toast.error('Add atleast 2 things to carry points');
            refs.thingsRef?.current?.scrollToAndHighlightField('carry');
            return;
        }

        const FAQ = formData.FAQ;
        for (let i = 0; i < FAQ.length; i++) {
            const faq = FAQ[i];

            if (typeof faq.question !== 'string' || faq.question.trim() === '') {
                toast.error(`Faq ${i + 1} question is required.`);
                refs.faqRef?.current?.scrollToAndHighlightField(`question${i}`);
                return;
            }

            if (typeof faq.answer !== 'string' || faq.answer.trim() === '') {
                toast.error(`Faq ${i + 1} answer is required.`);
                refs.faqRef?.current?.scrollToAndHighlightField(`answer${i}`);
                return;
            }
        }

        if (20 > tempData.terms.length || tempData.terms.length > 800) {
            toast.error('Add atleast 1 point to terms');
            refs.termsRef?.current?.scrollToAndHighlightField('terms');
            return;
        }

        if (formData.tags.length < 5) {
            toast.error('You should add minimum of 5 tags');
            refs.tagsRef?.current?.scrollToAndHighlightField('tags');
            return;
        }
        const checkTags = formData.tags.every((item) => {
            return item.length > 50;
        });
        if (checkTags) {
            toast.error('One of the tags length is greater than 50');
            return;
        }
    }
    setLoading(true);
    try {
        let data = formData;
        // if (formData.type === 'Camp') {
        //     data.included = tempData.included.split('\n').filter((line) => line.trim() !== '');
        //     data.excluded = tempData.excluded.split('\n').filter((line) => line.trim() !== '');
        //     data.terms = tempData.terms.split('\n').filter((line) => line.trim() !== '');
        //     data.safety = tempData.safety.split('\n').filter((line) => line.trim() !== '');
        //     data.carry = tempData.carry.split('\n').filter((line) => line.trim() !== '');
        // } else {
        //     delete data.quickView;
        //     delete data.FAQ;
        //     delete data.tags;
        //     delete data.videos;
        //     delete data.cardImages;
        //     delete data.images;
        // }
        let type = formData.type;

        // Walpaper Image Upload
        if (isEdit) {
            const uploadedNewImgs = imgData?.newWallImg?.length
                ? await Promise.all(imgData.newWallImg.map((file) => fileUpload(file, type, 'create', 'wallImg')))
                : [];
            data.images = [...(imgData.oldWallImg || []), ...uploadedNewImgs];
        } else {
            data.images = await Promise.all(
                imgData.newWallImg.map((file) => fileUpload(file, type, 'create', 'wallImg'))
            );
        }

        // Thumbnail Image Upload
        if (isEdit) {
            const uploadedNewImgs = imgData?.newThumbImg?.length
                ? await Promise.all(imgData.newThumbImg.map((file) => fileUpload(file, type, 'create', 'thumbImg')))
                : [];
            data.cardImages = [...(imgData.oldThumbImg || []), ...uploadedNewImgs];
        } else {
            data.cardImages = await Promise.all(
                imgData.newThumbImg.map((file) => fileUpload(file, type, 'create', 'thumbImg'))
            );
        }

        // Video upload
        if (isEdit) {
            if (videoFile instanceof File) {
                if (formData?.videos?.length > 0) {
                    await deleteFile(formData.videos[0]);
                }
                const videoURL = await fileUpload(videoFile, type, 'create', 'tripVideo');
                data.videos = [videoURL];
            } else if (
                (videoFile === null || videoFile === undefined || videoFile === '') &&
                formData?.videos?.length > 0
            ) {
                await deleteFile(formData.videos[0]);
                data.videos = [];
            } else {
                data.videos = formData.videos || [];
            }
        } else {
            if (videoFile instanceof File) {
                const videoURL = await fileUpload(videoFile, type, 'create', 'tripVideo');
                data.videos = [videoURL];
            } else {
                data.videos = [];
            }
        }

        if (formData.type === 'camp') {
            data.included = tempData.included.split('\n').filter((line) => line.trim() !== '');
            data.excluded = tempData.excluded.split('\n').filter((line) => line.trim() !== '');
            data.terms = tempData.terms.split('\n').filter((line) => line.trim() !== '');
            data.safety = tempData.safety.split('\n').filter((line) => line.trim() !== '');
            data.carry = tempData.carry.split('\n').filter((line) => line.trim() !== '');
        } else {
            delete data.quickView;
            delete data.FAQ;
            delete data.tags;
            delete data.videos;
            delete data.cardImages;
            delete data.images;
        }
        let res;
        if (formData.type === 'camp') {
            res = await orgCampRegisterFun(data);
        }
        if (formData.type === 'guide') {
            res = await orgGuidRegisterFun(data);
        }
        if (formData.type === 'activity') {
            res = await orgActRegisterFun(data);
        }
        if (res.status === 200) {
            toast.success('Organizer Registred Successfully, Please login');
            setLoading(false);
            return res;
        } else {
            toast.error('Error while Registering Organizer, Please try after some time');
            setLoading(false);
        }
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
